import type { HTMLText, Text } from 'pixi.js';
import { attachIntervalToDisplayObject, CountDownFormat, formatIntoUnitCountdown } from '../time-utils';
import { getLocalizedString } from '../../app/localization/getLocalizedString';

export function setTextAsTimerCountdown(timerText: Text | HTMLText, endTime: number): () => void {
  return attachIntervalToDisplayObject(
    timerText,
    () => {
      const timeLeft = endTime - Date.now();

      if (timeLeft < 0) {
        timerText.text = getLocalizedString('Ended');
        return;
      }

      timerText.text = formatIntoUnitCountdown(timeLeft, 2, CountDownFormat.DHMS);
    },
    1000,
  );
}
